<template>
    <!--机构报告-->
    <div class="statistic">
        <manage-wrapper>
            <el-page-header @back="$router.go(-1)" content="报告生成时间">
                <div slot="content">
                    报告生成时间:
                    <span style=" color: #FFA417; margin-left: 4px">{{getCurrentDate}}</span>
                </div>
            </el-page-header>
            <div class="stat-container">
                <div v-for="item in STAT_DATA" :key="item.value">
                    <span style="font-weight: 600; font-size: 18px; margin-right: 6px">{{statData[item.value] | getStat}}</span>
                    <span style="font-size: 13px">{{ item.unit }}</span>
                    <div style="margin-top: 10px">
                        <img :src="item.icon" alt="icon" width="17px" height="16px" style="vertical-align: middle">
                        <span style="vertical-align: middle; margin-left: 6px">{{ item.label }}</span>
                    </div>
                </div>
            </div>
            <div class="divider"/>
            <group-student-analyse/>
            <div class="divider"/>
            <group-question-analyse/>
            <div class="divider"/>
            <group-paper-analyse/>
            <div class="divider"/>
            <group-course-analyse/>
            <div class="divider"/>
            <group-exam-analyse/>
        </manage-wrapper>
    </div>
</template>

<script>
import ManageWrapper from "@/components/manage-wrapper/manage-wrapper";
import GroupStudentAnalyse from "./cpns/GroupStudentAnalyse"
import GroupQuestionAnalyse from "./cpns/GroupQuestionAnalyse";
import GroupPaperAnalyse from "./cpns/GroupPaperAnalyse";
import GroupCourseAnalyse from "./cpns/GroupCourseAnalyse";
import GroupExamAnalyse from "./cpns/GroupExamAnalyse";
import { STAT_DATA } from "./config"
import { getStatData } from "@/api/manage";
import { formatDate } from "element-ui/lib/utils/date-util"
export default {
    name: "statistic",
    components: { ManageWrapper, GroupStudentAnalyse, GroupQuestionAnalyse, GroupPaperAnalyse, GroupCourseAnalyse, GroupExamAnalyse },
    data() {
        return {
            STAT_DATA,
            currentSelect: 0,
            statData: {}
        }
    },
    filters: {
        getStat (val) {
            return Object.isObj(val) ? val.TotalQty : ""
        }
    },
    computed: {
        getCurrentDate () {
            return formatDate(new Date(), "yyyy年MM月dd日")
        }
    },
    created() {
        this.getStat()
    },
    methods: {
        // 获取统计数据
        getStat () {
            getStatData().then(res => {
                this.statData = res
            })
        },
    }
}
</script>

<style scoped lang="less">
.divider {
    background-color: #f1f2f6;
    height: 20px;
    margin: 30px -30px;
}

.stat-container {
    display: flex;
    margin-top: 21px;
    padding: 31px 0;

    > div {
        flex: 1;
        text-align: center;
        border-right: 1px solid #E5E8EC;

    }
}
</style>
